import { render, staticRenderFns } from "./EditFallDetectionAnalytics.vue?vue&type=template&id=3204d944"
import script from "./EditFallDetectionAnalytics.vue?vue&type=script&lang=js"
export * from "./EditFallDetectionAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports